// extracted by mini-css-extract-plugin
export var closeButton = "_nu-1";
export var closeX = "_nu-3";
export var container = "_nu-0";
export var image = "_nu-2";